import { useRouter } from "next/router";
import { useCallback } from "react";
import { useResetRecoilState } from "recoil";
import {
  finalizeTipVal,
  isSetTipFlag,
} from "src/components/features/common/cartCard/driverTipDialog";
import { useOrderHistory } from "src/components/features/order/history/useOrderHistory";
import { useGetCartList } from "src/modules/api/Shop/getCartList/getCartList";
import { useUserDeliveryAddressState } from "src/modules/domain/user/deliveryAddress/useUserDeliveryAddressState";

// Callback function to be executed when the order is successful.
export const useCallbackOrderSuccess = () => {
  const router = useRouter();

  const { deliveryAddressState: deliveryAddress, isReady: isAddressReady } =
    useUserDeliveryAddressState();
  const { mutate } = useGetCartList(
    {
      version: 2,
      latitude: `${deliveryAddress?.latitude}`,
      longitude: `${deliveryAddress?.longitude}`,
    },
    isAddressReady
  );

  const { mutateOrderHistory } = useOrderHistory();
  const resetFinalizeTipVal = useResetRecoilState(finalizeTipVal);
  const resetTipFlagVal = useResetRecoilState(isSetTipFlag);

  return useCallback(
    (orderNo: string) => {
      router.replace(`/order/detail/${orderNo}`);
      mutate();
      mutateOrderHistory();
      resetFinalizeTipVal();
      resetTipFlagVal();
    },
    [router, mutate, mutateOrderHistory, resetFinalizeTipVal, resetTipFlagVal]
  );
};
